import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean): void {
    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {
    return this.requestInFlight$.asObservable();
  }
}

@Injectable()
export class HTTPListener implements HttpInterceptor {
  private status = inject(HTTPStatus);
  private oAuth = inject(OAuthService);
  private router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        // remove calls to IDP server.
        const hideLoading = localStorage.getItem('hideLoading') === 'true';
        if (
          !req.url.includes(environment.identityServerUrl) &&
          !req.url.includes('proxy/ayuware') &&
          !req.url.includes('idealista/autocomplete') &&
          !hideLoading
        ) {
          this.status.setHttpStatus(true);
        }
        return event;
      }),
      catchError(error => {
        this.status.setHttpStatus(false);
        if (error.status !== 401) {
          return observableThrowError(error);
        }
        this.oAuth.logOut();
        return observableThrowError(error);
      }),
      finalize(() => {
        this.status.setHttpStatus(false);
      })
    );
  }
}
